exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".default-menu-item,\n:host {\n  position: relative;\n  width: 430px;\n  display: block;\n  height: 100vh;\n  overflow: hidden;\n}\ndiv.cases {\n  box-sizing: border-box;\n  height: 100%;\n  overflow: hidden;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/user/projects/ansyn/src/app/packages/menu-items/cases/components/cases/cases.component.less
// module id = ../../../../../src/app/packages/menu-items/cases/components/cases/cases.component.less
// module chunks = main